import { render, staticRenderFns } from "./wSelect.vue?vue&type=template&id=3ae65a26&scoped=true&"
import script from "./wSelect.vue?vue&type=script&lang=js&"
export * from "./wSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae65a26",
  null
  
)

export default component.exports